import { meta } from "../src/landingPage/datasets/meta";
import { NextHead } from "../src/landingPage/layouts/LayoutComponents/NextHead";
import { LegalTemplate } from "../src/landingPage/views/LegalPages/template/LegalTemplate";
import { withLegalHtml } from "../src/utils/server";

const PrivacyPage = ({ content }) => {
  return (
    <>
      <NextHead
        currentPath="/privacy-policy"
        title={meta.privacy.title}
        description={meta.privacy.description}
      />
      <LegalTemplate>{content}</LegalTemplate>
    </>
  );
};

export const getServerSideProps = withLegalHtml("privacy_policy", {
  wrapper: "MarketingWrapper",
});

export default PrivacyPage;
